import React from 'react';
import { WidgetOperative } from './WidgetOperative';
import { UnframedTest } from './test/UnframedTest';
import { WidgetTest } from './test/WidgetTest';

interface AppProps {
    pathname: string;
}

/**
 * This component is the main router for all paths relating to RC3.
 */
export function App({ pathname }: AppProps) {
    // Determine which component to render based on the pathname
    let element;
    switch (pathname) {
        case '/':
        case '/support/streamingdemo':
        case '/support/conversational':
            element = <WidgetTest />;
            break;
        case '/noframe':
            element = <UnframedTest />;
            break;
        case '/widget':
            element = <WidgetOperative />;
            break;
        default:
            element = <div>404 Not Found</div>; // Fallback for undefined routes
    }

    return (
        <div className='AppTheme' style={{ width: '100%' }}>
            {element}
        </div>
    );
}
